<template>
    <div>
        <van-nav-bar style="" title="设置"/>
        <van-cell-group>
            <van-cell title="系统版本号" value="v0.9.1"/>
            <van-cell title="软件名称" value="北京信泽信贷审批系统"/>
            <van-cell title="当前用户" :value="name"/>
            <van-cell title="所属公司/部门" :value="companyName"/>
            <van-cell title="退出登录" clickable @click="logout"/>
        </van-cell-group>
    </div>
</template>

<script>
    import store from '@/vue/store'
    import { mapGetters } from 'vuex'

    export default {
        name: 'home_index',
        components: {},
        data: function () {
            return {}
        },
        computed: mapGetters([
            'name',
            'companyName'
        ]),
        methods: {
            logout() {
                store.dispatch('Logout').then(() => {
                    this.$toast('退出成功')
                    setTimeout(() => {
                        this.$router.push({path: '/login'})
                    }, 500)
                })
            }
        }
    }
</script>

<style>
    .grid {
        font-size: 14px;
        text-align: center;
        padding: 20px 10px;
    }

    .grid img {
        width: 28px;
        height: 28px;
    }

    .center {
        text-align: center;
    }

    .menu {
    }

    .item {
        font-size: 14px;
        width: 25%;
        float: left;
    }
</style>
